import { useMemo } from "react";

import { Button, useBreakpoints } from "@sorcery/ui";

import { useSampleHand } from "~/providers/SampleHandProvider";
import { HandCard } from "./HandCard";

export const SampleHand = () => {
  const { hand, drawHand, drawSpell, drawSite } = useSampleHand();
  const { isXl, isMd, isSm, isLg, is2xl } = useBreakpoints();

  const maxHandWidth = useMemo(
    () =>
      Math.min(
        // single card max width
        254.6 * hand.length,
        is2xl ? 1100 : isXl ? 1000 : isLg ? 800 : isMd ? 600 : isSm ? 450 : 320,
      ),
    [hand.length, is2xl, isLg, isMd, isSm, isXl],
  );

  return (
    <>
      <div
        className="relative mx-auto mb-8 flex transition-all lg:mb-12"
        style={{
          maxWidth: maxHandWidth,
        }}
      >
        {hand.map((card, i) => (
          <HandCard deckCard={card} index={i} key={card.id} handLength={hand.length} />
        ))}
      </div>

      <div className="mb-4 flex flex-row justify-center" style={{ marginBottom: "1rem" }}>
        <Button variant={"outline"} className="m-1" onClick={() => drawSpell()}>
          Draw spell
        </Button>

        <Button variant={"outline"} className="m-1" onClick={() => drawSite()}>
          Draw site
        </Button>

        <Button variant={"outline"} className="m-1" onClick={() => drawHand()}>
          Reset
        </Button>
      </div>
    </>
  );
};
